import styled from 'styled-components';
import theme from './theme';

const Footer = styled.footer`
  margin: 0;
  padding: ${theme.margin};
`;

export default Footer;
